"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveFile = moveFile;
exports.removeFile = removeFile;
exports.renameFile = renameFile;
exports.uploadFiles = uploadFiles;
exports.getFetchVideoFileByPlayerIdAttemptedAction = getFetchVideoFileByPlayerIdAttemptedAction;
exports.getFetchVideoFileByPlayerIdFailedAction = getFetchVideoFileByPlayerIdFailedAction;
exports.getFetchVideoFileByPlayerIdSuccessAction = getFetchVideoFileByPlayerIdSuccessAction;
exports.fetchVideoFileByPlayerId = fetchVideoFileByPlayerId;
exports.getSaveFileEditAttemptedAction = getSaveFileEditAttemptedAction;
exports.getSaveFileEditSuccessAction = getSaveFileEditSuccessAction;
exports.getSaveFileEditFailedAction = getSaveFileEditFailedAction;
exports.updateFileMeta = updateFileMeta;

var _I18n = _interopRequireDefault(require("I18n"));

var Actions = _interopRequireWildcard(require("FileManagerCore/actions/Files"));

var _validation = require("FileManagerLib/utils/validation");

var _Actions = require("FileManagerLib/actions/Actions");

var _ActionTypes = require("FileManagerLib/actions/ActionTypes");

var VideoPlayersApi = _interopRequireWildcard(require("FileManagerCore/api/VideoPlayers"));

var FilesApi = _interopRequireWildcard(require("FileManagerCore/api/Files"));

function moveFile(file, destination) {
  return function (dispatch) {
    dispatch(Actions.moveFile(file, destination));
    dispatch((0, _Actions.trackInteraction)('Manage Files', 'move'));
  };
}

function removeFile(file) {
  return function (dispatch) {
    dispatch(Actions.removeFile(file));
    dispatch((0, _Actions.trackInteraction)('Manage Files', 'delete'));
  };
}

function renameFile(file, newName) {
  return function (dispatch) {
    dispatch(Actions.renameFile(file, newName));
    dispatch((0, _Actions.trackInteraction)('Manage Files', 'rename'));
  };
}

function uploadFiles(fileList, options) {
  return function (dispatch) {
    var type = options.type;
    var files = Array.prototype.slice.call(fileList);
    var validator = (0, _validation.getValidator)(type);
    var validFiles = [];

    if (validator) {
      files.forEach(function (file) {
        if (validator(file)) {
          validFiles.push(file);
        }
      });
    } else {
      validFiles = files;
    }

    dispatch(Actions.uploadFiles(validFiles, options));
  };
}

function getFetchVideoFileByPlayerIdAttemptedAction() {
  return {
    type: _ActionTypes.FETCH_FILE_FOR_EDITING_ATTEMPTED
  };
}

function getFetchVideoFileByPlayerIdFailedAction() {
  return {
    type: _ActionTypes.FETCH_FILE_FOR_EDITING_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.editVideo.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.editVideo.error.message')
      }
    }
  };
}

function getFetchVideoFileByPlayerIdSuccessAction(file) {
  return {
    type: _ActionTypes.FETCH_FILE_FOR_EDITING_SUCCEEDED,
    file: file
  };
}

function fetchVideoFileByPlayerId(playerId) {
  return function (dispatch, getState, httpClient) {
    dispatch(getFetchVideoFileByPlayerIdAttemptedAction());
    VideoPlayersApi.fetchVideoFileByPlayerId(playerId, httpClient).then(function (resp) {
      dispatch(getFetchVideoFileByPlayerIdSuccessAction(resp.get(0)));
    }, function () {
      dispatch(getFetchVideoFileByPlayerIdFailedAction());
    }).done();
  };
}

function getSaveFileEditAttemptedAction() {
  return {
    type: _ActionTypes.SAVE_FILE_EDIT_ATTEMPTED
  };
}

function getSaveFileEditSuccessAction(file) {
  return {
    type: _ActionTypes.SAVE_FILE_EDIT_SUCCEEDED,
    file: file
  };
}

function getSaveFileEditFailedAction() {
  return {
    type: _ActionTypes.SAVE_FILE_EDIT_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.editFile.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.editFile.error.message')
      }
    }
  };
}

function updateFileMeta(fileId, data) {
  return function (dispatch, getState, httpClient) {
    dispatch(getSaveFileEditAttemptedAction());
    return FilesApi.updateFileMeta(fileId, data, httpClient).then(function (file) {
      dispatch(getSaveFileEditSuccessAction(file));
    }, function () {
      dispatch(getSaveFileEditFailedAction());
    });
  };
}